export const isNavigationKey = (key: string) => key.length > 1;
